import axios from "axios";

/*
 * The pane lives in an iframe on Word Online, where WHG Docs' session cookie
 * is a third-party cookie and usually not sent. It therefore carries its own
 * bearer token, minted by the sign-in dialog, kept for this Word session.
 */

const API_URL = process.env.REACT_APP_API_URL;
const TOKENS_KEY = "whgdocs.wordAddin.tokens";

export const getTokens = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(TOKENS_KEY) || "null");
  } catch (e) {
    return null;
  }
};

export const setTokens = (tokens) => {
  if (tokens) window.sessionStorage.setItem(TOKENS_KEY, JSON.stringify(tokens));
  else window.sessionStorage.removeItem(TOKENS_KEY);
};

export const addinApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

addinApi.interceptors.request.use((config) => {
  const tokens = getTokens();
  if (tokens?.access) config.headers.Authorization = `Bearer ${tokens.access}`;
  return config;
});

export const fetchContext = (params) => addinApi.get("/word-addin/context/", { params });
export const publishDraft = (formstackId) =>
  addinApi.post(`/formstack/templates/${encodeURIComponent(formstackId)}/word-draft/publish/`);
export const fetchDraftStatus = (formstackId) =>
  addinApi.get(`/formstack/templates/${encodeURIComponent(formstackId)}/word-draft/`);

// The review reads the whole brief in one go and takes about a minute; the
// server allows five before it gives up, so the pane waits that long too.
export const REVIEW_TIMEOUT_MS = 5 * 60 * 1000;
export const reviewBrief = (payload) => addinApi.post("/word-addin/brief-review/", payload, { timeout: REVIEW_TIMEOUT_MS });
export const fetchReviewRules = () => addinApi.get("/word-addin/brief-review/rules/");

export const isAuthError = (err) => err?.response?.status === 401 || err?.response?.status === 403;
